const FreeTrialTag = () => {
    return (
        <span className="ml-[12px] px-[4px] py-[2px] text-caption1 text-white-900 bg-black-700 rounded-[4px] uppercase">
            Free Trial
        </span>
    )
}

export default FreeTrialTag
